import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class AHomeComponent implements OnInit {


    ngOnInit(): void {
         
    }

}